import { BADGE_STATUS, type BadgeStatus } from "@regal-voice/ui";
import { JourneyStatus } from "Types/Journey";

export function isNewJourney(journeyId: string): boolean {
    return journeyId == "new" || journeyId == "duplicate";
}

export function getJourneyState(status: string): { label: string; status: BadgeStatus } {
    return status == JourneyStatus.LIVE
        ? { label: "Live", status: BADGE_STATUS.ACTIVE }
        : { label: "Draft", status: BADGE_STATUS.PENDING };
}
